<template>
  <div class="tab-group">
    <div :class="tabsGroupClasses">
      <div
        v-for="(tab, i) in tabs"
        :id="tab.selector ? tab.selector : null"
        :key="i"
        @click="onClickTab(tab)"
        :class="tabClasses(tab)"
      >
        <span v-html="tab.title"></span>
      </div>
      <slot name="behindTabs"></slot>
    </div>
    <div :class="'tab-group__body' + (pills ? ' tab-group__body--pills' : '')">
      <div
        v-for="(definedSlot, id) in this.$slots"
        :key="id"
        :class="'tab-group__content' + (activeTabId === id ? ' tab-group__content--open' : '')"
      >
        <slot :name="id + ''"></slot>
      </div>
      <div v-if="this.$slots.content" class="tab-group__content tab-group__content--open">
        <slot name="content"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "M4TabGroup",
  data: function () {
    let firstTab = this.tabs.find((tab, i) => i === 0);
    return {
      activeTabId: this.active ? this.active : firstTab ? firstTab.id : null
    };
  },
  props: {
    title: String,
    active: String,
    urlRedirect: {
      type: Boolean,
      default: function () {
        return false;
      }
    },
    pills: {
      type: Boolean,
      default: function () {
        return false;
      }
    },
    center: {
      type: Boolean,
      default: function () {
        return false;
      }
    },
    tabs: {
      type: Array,
      default: function () {
        return [];
      }
    },
    afterMountedSetTabId: {
      type: Boolean,
      default: function () {
        return true;
      }
    }
  },
  emits: ["setActiveTabId"],
  mounted() {
    let currTabId = this.getCurrTabId();
    if (currTabId && this.afterMountedSetTabId) {
      this.activeTabId = currTabId;
    }

    this.$emit("setActiveTabId", this.activeTabId);
  },
  computed: {
    tabsGroupClasses() {
      let classes = ["tab-group_tabs"];
      if (this.pills) {
        classes.push("tab-group_tabs--pills");
      }
      if (this.center) {
        classes.push("tab-group_tabs--center");
      }
      return classes;
    }
  },
  methods: {
    onClickTab(tab) {
      this.setCurrTab(tab);
    },
    tabClasses(tab) {
      let classes = ["tab-group_tabs__tab"];
      if (this.isCurrTab(tab)) {
        classes.push("tab-group_tabs__tab--active");
      }
      return classes;
    },
    isCurrTab(tab) {
      return this.activeTabId === tab.id;
    },
    setCurrTab(tab) {
      if (this.urlRedirect && tab.url) {
        location.href = tab.url;
      } else {
        this.activeTabId = tab.id;
        if (this.afterMountedSetTabId) {
          sessionStorage.setItem("tab_" + location.pathname, tab.id);
        }
      }

      this.$emit("setActiveTabId", this.activeTabId);
    },
    getCurrTabId() {
      let currTabId = null;

      if (this.urlRedirect) {
        if (this.active) {
          currTabId = this.active;
        } else {
          this.tabs.map((tab) => {
            if (tab.url === location.protocol + "//" + location.host + location.pathname) {
              currTabId = tab.id;
            }
          });
        }
      } else {
        currTabId = sessionStorage.getItem("tab_" + location.pathname);

        if (location.hash) {
          let hash = location.hash.replace("#", "");
          this.tabs.map((tab) => {
            if (tab.id === hash) {
              currTabId = tab.id;
              let uri = window.location.toString();
              let cleanUri = uri.substring(0, uri.indexOf("#"));
              window.history.replaceState({}, document.title, cleanUri);
            }
          });
        }
      }

      if (currTabId) {
        return currTabId;
      }
      return false;
    }
  }
};
</script>
